import { Typography } from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import CardStatus from "@arelia-components/ui-atoms/CardStatus";
import { Widget } from "@arelia-types/widget";

type Props = {
  total: number;
  changes: number;
  loading: boolean;
  error: boolean;
  unconnected: boolean;
  widgetConfig: Widget;
};

export default function FollowersPresenter({ total, changes, loading, error, unconnected, widgetConfig }: Props) {
  return (
    <WidgetCard
      widgetId="FOLLOWERS"
      title="Followers"
      loading={loading}
      error={error}
      unconnected={unconnected}
      widgetConfig={widgetConfig}
    >
      <Typography variant="h2">{total} Total</Typography>
      <CardStatus color={changes > 0 ? "success.main" : "error"}>
        {changes > 0 ? (
          <ArrowUpward color="success" />
        ) : (
          <ArrowDownward color="error" />
        )}
        {Math.abs(Math.round(changes))}% FROM LAST WEEK
      </CardStatus>
    </WidgetCard>
  );
}
